import React, { useContext } from 'react';
import formatter from '../../../helpers/currencyMoney';
import '../../../styles/SearchOrders/customerOrders.scss';
import { Link, Outlet } from 'react-router-dom';
import { Table } from 'react-bootstrap';

export const CustomerOrders = (props) => {
  let { data } = props.data;
  let { token, email } = props;

/*  Context data: const { valuesContext, addUserInformation } = useContext(appContext); */

  const createDStructured = (data, index) => {
    let onlyDate = data.deliveryDate.split(' ');
    return (
      <tr key={index}>
        <td className="orderTD">{data.externalOrderId}</td>
        <td className="dateTD">{onlyDate[0] ? onlyDate[0] : data.deliveryDate}</td>
        <td className="totalOrderTD">{formatter.format(data.orderTotal)}</td>
        <td>
          <Link
            style={{ width: 'fit-content', textDecoration: 'none' }}
            className="styled-submit button button-1"
            to="pages/wedding-contest/testimonial"
            state={{
              internalState: data.orderID,
              externalState: data.externalOrderId,
              emailState: email,
              tokenState: token
            }}>
            <i>Start Story</i>
          </Link>
        </td>
      </tr>
    );
  };
  const createHeader = () => {
    return (
      <thead>
        <tr className="ff-meta fs-meta c-meta ta-l">
          <th scope="col">Order ID</th>
          <th scope="col">Delivery Date</th>
          <th scope="col">Order Total</th>
          <th scope="col" style={{ textAlign: 'center' }}>
            {' '}
            Action
          </th>
        </tr>
      </thead>
    );
  };
  const createEmptyHeader = () => {
    return (
      <thead>
        <tr className="ff-meta fs-meta c-meta ta-l">
          <th scope="col">No Orders Found</th>
        </tr>
      </thead>
    );
  };
  return (
    <div className="ordersCustomer font-family">
      <Table resposive="true" className=" account__table--expanded ">
        {data.length ? createHeader() : createEmptyHeader()}
        <tbody>{data.map((dt, index) => createDStructured(dt, index))}</tbody>
        <Outlet />
      </Table>
    </div>
  );
};
export default CustomerOrders;
